import { type ReactNode, createContext, useContext, useEffect, useMemo, useState } from 'react'
import { useCookies } from 'react-cookie'

import MockSconnStudyDataClient from '../../api/mockSconnStudyDataClient'
import SconnStudyData from '../../api/sconnStudyData'
import SconnStudyDataClient from '../../api/sconnStudyDataClient'
import { useNativeInteractor } from '../nativeInteractor/context'

import { type SconnStudyDataState } from './types'

export const SconnStudyDataApiContext = createContext<SconnStudyDataState | null>(null)

export function SconnStudyDataApiProvider({ children }: { children: ReactNode }) {
  const { interactor } = useNativeInteractor()
  const [cookies] = useCookies(['exp'])
  const isDevelopment = process.env.NODE_ENV === 'development'
  const [isTokenReady, setIsTokenReady] = useState(isDevelopment)

  const client = useMemo(
    () => (!isDevelopment ? new SconnStudyDataClient(interactor) : new MockSconnStudyDataClient()),
    [interactor, isDevelopment],
  )

  const sconnStudyData = useMemo(() => new SconnStudyData(client), [client])

  useEffect(() => {
    if (isDevelopment) return

    interactor
      .getNativeToken()
      .then((accessToken: string | undefined) => {
        if (accessToken) {
          sconnStudyData.setAccessToken(accessToken)
          sconnStudyData.setExpires(Number(cookies.exp))
          setIsTokenReady(true)
        }
      })
      .catch((e: any) => {
        console.log('callNativeFunction, error', e)
      })
  }, [cookies.exp, interactor, isDevelopment, sconnStudyData])

  return (
    <SconnStudyDataApiContext.Provider value={{ sconnStudyData, isTokenReady }}>
      {children}
    </SconnStudyDataApiContext.Provider>
  )
}

export function useSconnStudyDataApi() {
  const context = useContext(SconnStudyDataApiContext)

  if (context === null) {
    throw Error('SconnStudyData instance is null: Cannot proceed with operation.')
  }

  return context
}
